let env = process.env;
let url = null;

/***
 *
 *
 * @test
 * @pre
 * @production
 * @localhost
 *
 */

const types = {
  test: {
    common: "//staff-api.p2e.cd",
    static: "//static.p2e.cd",
    home: "http://www.p2e.cd",
  },
  pre: {
    common: "//staff-api.pre.p2e.game",
    static: "//static.pre.p2e.game",
    home: "http://www.pre.p2e.game",
  },
  production: {
    common: "https://staff-api.p2e.game",
    static: "https://static.p2e.game",
    home: "https://www.p2e.game",
  },
  localhost: {
    common: "//staff-api.p2e.cc",
    static: "//static.p2e.cc",
    // common: "//staff-api.pre.p2e.game",
    // static: "//static.pre.p2e.game",
    home: "http://localhost:3000",
  },
};

if (env.VUE_APP_TYPE === "test") {
  url = types.test;
} else if (env.VUE_APP_TYPE === "pre") {
  url = types.pre;
} else if (env.NODE_ENV === "production") {
  url = types.production;
} else {
  url = types.localhost;
}

export const baseUrl = url;
export const staticUrl = url.static;
export const homeUrl = url.home;

export const uploadFile = url.common + "/upload.json"; // yang
export const uploadUrl = url.common + "/v2/files/upload.json"; // yang
export const typeFilters = {
  genre: "Game Genre",
  game_chain: "Game Chain",
  game_device: "Game Device",
  game_phase: "Game Phase",
  game_f2p: "Game F2P",
  game_p2e: "Game P2E",
  game_nft: "Game NFT",
  game_launch_quarter: "Game Launch Quarter",
  lang: "Language",
  lang_pkg: "Language Package",
  seo: "SEO",
  community: "Community",
  daily_news_cate: "Daily News Category",
  daily_news_tag: "Daily News Tag",
  news_tag: "News Tag",
  news_source: "News Source",
  ido_phase: "IDO Phase",
  ido_chain: "IDO Chain",
  dis_chain: "Distribution  Chain",
  nft_phase: "NFT Phase",
  nft_chain: "NFT Chain",
  nft_cate: "NFT Category",
  station_rule_field: "Station Rule Field",
  mission_type: "Mission Type",
  user_level: "User Level",
  medal_type: "Medal Type",
  link: "Link",
  help_cate: "Article Center Category",
  article_center_tag:'Article Center Tag',
  game_tag:"Game Tag",
  ino_phase:"INO Phase",
  report_type: "Report Type",
  community_cate:"Community Cate",
  community_label:"Community Label",
};
